import _ from 'lodash'
import { Jsep } from 'jsep'
import jsepObject from '@jsep-plugin/object'
import jsepTemplate from '@jsep-plugin/template'

const CACHE = {}

Jsep.plugins.register(jsepObject)
Jsep.plugins.register(jsepTemplate)

Jsep.plugins.register({
  name: 'task',
  init (jsep) {
    jsep.hooks.add('gobble-token', function (arg) {
      if (this.char === '@') {
        const start = this.index
        let openParenIndex = null
        let taskArg = null

        while (![jsep.SPACE_CODE, jsep.CPAREN_CODE, jsep.LF_CODE, jsep.CR_CODE].includes(this.code) && this.index < this.expr.length) {
          if (this.code === jsep.OPAREN_CODE) {
            openParenIndex = this.index
            this.index++
            taskArg = this.gobbleToken()
          }

          this.index++
        }

        const [task, name = ''] = _.split(this.expr.slice(start, openParenIndex || this.index), '::')

        arg.node = _.pickBy({
          type: 'Task',
          task,
          name,
          taskArg
        })
      }
    })
  }
})

Jsep.plugins.register({
  name: 'annotation',
  init (jsep) {
    jsep.hooks.add('gobble-token', function (arg) {
      if (this.char === '#') {
        const start = this.index

        while (![jsep.COLON_CODE].includes(this.code) && this.index < this.expr.length) {
          this.index++
        }

        this.index++

        arg.node = {
          type: 'Annotation',
          annotation: this.expr.slice(start + 1, this.index - 1),
          expression: this.gobbleToken()
        }
      }
    })
  }
})

Jsep.plugins.register({
  name: 'vrn',
  init (jsep) {
    jsep.hooks.add('gobble-token', function (arg) {
      if (this.char === 'v') {
        const start = this.index
        const isVrn = this.expr.slice(start, start + 4) === 'vrn:'

        if (isVrn) {
          while (![jsep.SPACE_CODE, jsep.CPAREN_CODE, jsep.LF_CODE, jsep.CR_CODE].includes(this.code) && this.index < this.expr.length) {
            this.index++
          }

          arg.node = {
            type: 'Vrn',
            vrn: this.expr.slice(start, this.index)
          }
        }
      }
    })
  }
})

export default class Parser {
  constructor (enableCache = false) {
    this.enableCache = !!process.env.ENABLE_EXPRESSION_CACHE || enableCache
  }

  parse (formula) {
    try {
      if (formula && _.isString(formula)) {
        if (this.enableCache) {
          if (!_.has(CACHE, [formula])) {
            const jsep = new Jsep(formula)
            _.set(CACHE, [formula], jsep.parse())
          }

          return _.get(CACHE, [formula])
        }

        const jsep = new Jsep(formula)
        return jsep.parse()
      }
    } catch (error) {
      error.statusCode = 400
      error.formula = _.toString(formula)

      throw error
    }
  }
}
